/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropzone.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/dropzone/dropzone.component';
const styles_DropzoneComponent:any[] = [i0.styles];
export const RenderType_DropzoneComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DropzoneComponent,data:{}});
export function View_DropzoneComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{divEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['div',
      1]],(null as any),0,'div',[['class','dropzone']],(null as any),(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_DropzoneComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropzone',
      ([] as any[]),(null as any),(null as any),(null as any),View_DropzoneComponent_0,
      RenderType_DropzoneComponent)),i1.ɵdid(4374528,(null as any),0,i2.DropzoneComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DropzoneComponentNgFactory:i1.ComponentFactory<i2.DropzoneComponent> = i1.ɵccf('admin-dropzone',
    i2.DropzoneComponent,View_DropzoneComponent_Host_0,{url:'url'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Ryb3B6b25lL2Ryb3B6b25lLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9kcm9wem9uZS9kcm9wem9uZS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9kcm9wem9uZS9kcm9wem9uZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Ryb3B6b25lL2Ryb3B6b25lLmNvbXBvbmVudC50cy5Ecm9wem9uZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgI2RpdiBjbGFzcz1cImRyb3B6b25lXCI+PC9kaXY+IiwiPGFkbWluLWRyb3B6b25lPjwvYWRtaW4tZHJvcHpvbmU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O21EQ0FBO01BQUE7TUFBQTs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/dropzone/dropzone.component.ngfactory.ts